/**
 * Builds the editor URL for a Study-home recency row.
 *
 * Board cards and writing-board pieces live on different routes, so the row's
 * channel kind picks the branch. Both carry the target document as `?doc=`,
 * which the editor hosts consume via `useDocumentDeepLink`.
 */

import { CHANNEL_KIND } from '../types/channelKind';

import type { StudyRecentDocument } from '../services/studyApi';

/** Query param naming the document to open inside a card's editor. */
export const DOC_PARAM = 'doc';

/**
 * Return the editor URL for a recency row, or `null` when its channel kind has
 * no editor route.
 */
export function buildDocumentUrl(row: StudyRecentDocument): string | null {
  const doc = `?${DOC_PARAM}=${encodeURIComponent(row.id)}`;
  if (row.channel_kind === CHANNEL_KIND.board) {
    return `/study/${row.channel_id}/board/edit/${row.card_id}${doc}`;
  }
  if (row.channel_kind === CHANNEL_KIND.writing) {
    return `/study/writing/${row.channel_id}/edit/${row.card_id}${doc}`;
  }
  return null;
}
